export default __webpack_public_path__ + "static/media/covenantofarms.ff138aec.png";